<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> CONCILIAÇÃO PEDIDO X NOTA FISCAL </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      >
      </alert>
      <v-form
        ref="form"
        class="compact-form"
        v-model="valid"
        :lazy-validation="lazy"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :items="companies_providers"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="invoice.provider"
                label="Fornecedor"
                @change="handleChangeProvider()"
                hide-details
                clearable
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="invoice.franchise"
                label="Franqueado"
                ref="franchise"
                @change="handleChangeFranchise()"
                hide-details
                clearable
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" md="4">
              <v-row>
                <v-col cols="12" xs="6" sm="8" md="6">
                  <v-subheader>Número / Série da Nota</v-subheader>
                </v-col>
                <v-col cols="12" xs="6" sm="4" md="6">
                  <div style="width: 80px; float: left">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="invoice.number"
                      ref="number"
                      @blur="getInvoice()"
                    ></v-text-field>
                  </div>
                  <div style="width: 40px; float: left; margin-left: 5px">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="invoice.serie"
                      @blur="getInvoice()"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-text-field
                outlined
                dense
                hide-details
                label="Data Emissão"
                v-mask="dateMask"
                v-model="invoice.issue_date"
                ref="issue_date"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handleClickCalendar()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-text-field-money
                v-model="invoice.value"
                label="Valor Total dos Produtos"
                v-bind:properties="{
                  prefix: '',
                  readonly: false,
                  dense: true,
                  hideDetails: true,
                  outlined: true,
                  clearable: false,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              />
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-text-field-money
                v-model="invoice.value_total"
                label="Valor Total da Nota"
                v-bind:properties="{
                  prefix: '',
                  readonly: false,
                  dense: true,
                  hideDetails: true,
                  outlined: true,
                  clearable: false,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              />
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-currency-field
                label="(R$) Ajustes"
                dense
                hide-details
                outlined
                @blur="handleBlurAdjustment"
                v-model="invoice.adjustment"
              />
              <!-- <v-text-field-money
                v-model="invoice.adjustment"
                label="(R$) Ajustes"
                v-bind:properties="{
                  prefix: '',
                  readonly: false,
                  dense: true,
                  hideDetails: true,
                  outlined: true,
                  clearable: false,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              /> -->
            </v-col>
            <v-col cols="12" xs="6" md="1">
              <v-text-field
                outlined
                dense
                hide-details
                label="Qt. Total"
                v-model="invoice.quantity"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-text-field-money
                v-model="invoice.discount"
                label="(R$) Descontos"
                v-bind:properties="{
                  prefix: '',
                  readonly: false,
                  dense: true,
                  hideDetails: true,
                  outlined: true,
                  clearable: false,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              />
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-text-field-money
                v-model="invoice.addition"
                label="(R$) Acréscimos"
                v-bind:properties="{
                  prefix: '',
                  readonly: false,
                  dense: true,
                  hideDetails: true,
                  outlined: true,
                  clearable: false,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-text-field
                outlined
                dense
                hide-details
                label="Observação"
                class="text-field-uppercase"
                v-model="invoice.observation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-5">
              <label class="font-weight-bold mt-2"
                >Total Produtos + Ajustes:
              </label>
              {{ getTotalValueAdjustment() | currencyEuaToBr }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card>
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold"
                  dense
                  outlined
                  tile
                  dark
                  height="28"
                  >DETALHAMENTO DE PEDIDOS</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col cols="12" xs="6" md="6">
                      <v-btn
                        dark
                        color="green darken-3"
                        small
                        @click="openModalOrder()"
                      >
                        <v-icon left> mdi-plus </v-icon>
                        Adicionar Pedido
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="200">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-no-wrap" width="90px">
                                Pedido
                              </th>
                              <th class="text-left text-no-wrap">Emissão</th>
                              <th class="text-left text-no-wrap">Estimativa</th>
                              <th class="text-right text-no-wrap" width="60px">
                                Qt. Prod.
                              </th>
                              <th class="text-right text-no-wrap">Valor</th>
                              <th class="text-right text-no-wrap" width="60px">
                                Qt. Pend.
                              </th>
                              <th class="text-right text-no-wrap">Vr. Pend.</th>
                              <th class="text-left text-no-wrap" width="60px">
                                Qt. Atend.
                              </th>
                              <th class="text-left text-no-wrap" width="60px">
                                Vr. Atend.
                              </th>
                              <th class="text-left" style="max-width: 70px">
                                Situação
                              </th>
                              <th class="text-left text-no-wrap" width="80px">
                                Ação
                              </th>
                              <th class="text-center text-no-wrap" width="40px">
                                Indenização
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="order in orders_selected"
                              :key="order.id"
                            >
                              <td>
                                {{ order.franchise.code }}{{ order.code }}
                              </td>
                              <td>{{ order.issuance_date | dateToBr }}</td>
                              <td>{{ order.estimate_date | dateToBr }}</td>
                              <td class="text-right">
                                {{ order.quantity_products }}
                              </td>
                              <td class="text-right">
                                {{ order.value_total | currencyEuaToBr }}
                              </td>
                              <td class="text-right">
                                {{ order.quantity_outstanding }}
                              </td>
                              <td class="text-right">
                                {{ order.value_outstanding | currencyEuaToBr }}
                              </td>
                              <td>
                                <v-text-field
                                  label=""
                                  v-model="order.quantity_served"
                                  outlined
                                  dense
                                  hide-details
                                  @blur="handleBlurQuantityServed(order)"
                                  class="fs-12"
                                  style="min-width: 80px"
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field-money
                                  v-model="order.value_served"
                                  class="fs-12"
                                  @blur="handleBlurValueServed(order)"
                                  style="min-width: 110px"
                                  v-bind:properties="{
                                    prefix: '',
                                    readonly: false,
                                    dense: true,
                                    hideDetails: true,
                                    outlined: true,
                                    clearable: false,
                                    placeholder: ' ',
                                  }"
                                  v-bind:options="{
                                    locale: 'pt-BR',
                                    length: 11,
                                    precision: 2,
                                    empty: null,
                                  }"
                                />
                              </td>
                              <td class="">
                                {{ getStatus(order.status) }}
                              </td>
                              <td>
                                <v-tooltip top color="error">
                                  <!-- eslint-disable-next-line -->
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="red darken-1"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="deleteOrder(order)"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                  <span>Deletar</span>
                                </v-tooltip>
                              </td>
                              <td
                                v-if="order.restitution == 1"
                                class="text-center"
                              >
                                <v-tooltip top color="info">
                                  <!-- eslint-disable-next-line -->
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="blue darken-1"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      mdi-cash-refund
                                    </v-icon>
                                  </template>
                                  <span>Indenização</span>
                                </v-tooltip>
                              </td>
                              <td v-else></td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th class="text-right">
                                {{ getTotalSum("quantity_products") }}
                              </th>
                              <th class="text-right">
                                {{
                                  getTotalSum("value_total") | currencyEuaToBr
                                }}
                              </th>
                              <th class="text-right">
                                {{ getTotalSum("quantity_outstanding") }}
                              </th>
                              <th class="text-right">
                                {{
                                  getTotalSum("value_outstanding")
                                    | currencyEuaToBr
                                }}
                              </th>
                              <th class="">
                                {{ getTotalSum("quantity_served") }}
                              </th>
                              <th>
                                {{
                                  getTotalSum("value_served") | currencyEuaToBr
                                }}
                              </th>
                              <th></th>
                              <th></th>
                              <th></th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn dark color="blue darken-3" small @click="validate">
                    <v-icon left> mdi-check </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="red darken-2"
                    small
                    :disabled="invoice.id === ''"
                    @click="deleteInvoice()"
                    class="white--text"
                  >
                    <v-icon left>mdi-close</v-icon>
                    Excluir
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
    <v-dialog ref="dialog" v-model="modalOrderAdd" max-width="90%">
      <v-card>
        <v-card-title>
          <span class="text-h5">Pedidos</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" lg="6" class="py-1">
                <label for="">Fornecedor: </label>
                <strong>{{ getProviderSelected() }}</strong>
              </v-col>
              <v-col cols="12" lg="6" class="py-1">
                <label for="">Franqueado: </label>
                <strong>{{ getFranchiseSelected() }}</strong>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="6" lg="3" class="py-1">
                <v-text-field
                  label="Pedido"
                  outlined
                  dense
                  hide-details
                  v-model="order_code_filter"
                  class="fs-12"
                  style="min-width: 120px"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-simple-table dense fixed-header height="250">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th></th>
                        <th class="text-left text-no-wrap">Pedido</th>
                        <th class="text-left text-no-wrap">Situação</th>
                        <th class="text-left text-no-wrap">Emissão</th>
                        <th class="text-left text-no-wrap">Estimativa</th>
                        <th class="text-right text-no-wrap">Qt. Produtos</th>
                        <th class="text-right text-no-wrap">Valor</th>
                        <th class="text-right text-no-wrap">Qt. Pend.</th>
                        <th class="text-right text-no-wrap">Vr. Pend.</th>
                        <th class="text-center text-no-wrap">Indenização</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="order in filterSearchInput(orders_filtered)"
                        :key="order.id"
                      >
                        <td>
                          <v-checkbox
                            v-model="orders_selected_modal"
                            :value="order.id"
                            hide-details
                            label=""
                            class="mt-1"
                          ></v-checkbox>
                        </td>
                        <td>
                          {{ getFranchiseSelectedCode() }} {{ order.code }}
                        </td>
                        <td>
                          {{ getStatus(order.status) }}
                        </td>
                        <td class="text-no-wrap">
                          {{ order.issuance_date | dateToBr }}
                        </td>
                        <td class="text-no-wrap">
                          {{ order.estimate_date | dateToBr }}
                        </td>
                        <td class="text-no-wrap text-right">
                          {{ order.quantity_products }}
                        </td>
                        <td class="text-right">
                          {{ order.value_total | currencyEuaToBr }}
                        </td>
                        <td class="text-right">
                          {{ order.quantity_outstanding }}
                        </td>
                        <td class="text-right">
                          {{ order.value_outstanding | currencyEuaToBr }}
                        </td>
                        <td v-if="order.restitution == 1" class="text-center">
                          <v-tooltip top color="info">
                            <!-- eslint-disable-next-line -->
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="blue darken-1"
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-cash-refund
                              </v-icon>
                            </template>
                            <span>Indenização</span>
                          </v-tooltip>
                        </td>
                        <td v-else></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="handleConfirmModal"> Confirmar </v-btn>
          <v-btn text color="primary" @click="modalOrderAdd = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showConfirmEdit" persistent max-width="500px">
      <v-card>
        <v-toolbar color="blue lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-text class="text-h6 mt-4"
          >Já existe essa nota no sistema, deseja editar?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            class="white--text"
            @click="confirmEditOrder"
          >
            <v-icon left>mdi-file</v-icon> Editar
          </v-btn>
          <v-btn color="gray darken-1" @click="cancelEditOrder">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDialogDeleteInvoice" max-width="500px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja Deletar?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showDialogDeleteInvoice = false"
            >Fechar</v-btn
          >
          <v-btn
            color="red darken-1"
            @click="confirmDeleteInvoice"
            class="white--text"
          >
            <v-icon dark>mdi-delete</v-icon>
            Deletar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";
import { getStatusName } from "@/helpers/order_status";

import AwesomeMask from "awesome-mask";

export default {
  props: ["franchise_id", "provider_id"],
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    companies: [],
    companies_providers: [],
    invoice: {
      id: "",
      franchise: "",
      provider: "",
      issue_date: "",
      number: "",
      serie: "1",
      observation: "",
      value: "0.00",
      addition: "0.00",
      value_total: "0.00",
      adjustment: "0.00",
      discount: "0.00",
      quantity: "0",
    },
    loading: false,
    typeAlert: "error",
    showAlert: false,
    messageAlert: false,
    lazy: false,
    valid: true,
    dateDialog: "",
    modalDate: false,
    orders: [],
    orders_selected: [],
    orders_filtered: [],
    orders_selected_modal: [],
    modalOrderAdd: false,
    order_code_filter: "",
    order_edit: {},
    showConfirmEdit: false,
    showDialogDeleteInvoice: false,
    editAuto: false,
  }),
  computed: {},
  created() {
    this.initialize();
  },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateToBr: function (date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
  },
  methods: {
    async initialize() {
      this.getCompanies();
      this.getProviders();
      if (Object.keys(this.$route.params).length > 0) {
        this.invoice.franchise = parseInt(this.$route.params.franchise_id);
        this.invoice.provider = parseInt(this.$route.params.provider_id);
        this.invoice.number = parseInt(this.$route.params.number);
        this.invoice.serie = parseInt(this.$route.params.serie);
        this.editAuto = true;
        this.getInvoice();
      }
    },
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getProviders() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.companies_providers = data.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
      } catch (error) {
        this.companies_providers = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    validate() {
      if (this.invoice.provider == "") {
        this.messageAlert =
          "É necessário selecionar um Fornecedor para poder continuar";
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }

      if (this.invoice.franchise == "") {
        this.messageAlert =
          "É necessário selecionar um Franqueado para poder continuar";
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }

      if (this.invoice.number == "") {
        this.messageAlert =
          "É necessário preencher um Número de Nota para poder continuar";
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }

      if (this.invoice.serie == "") {
        this.messageAlert =
          "É necessário preencher uma Série de Nota para poder continuar";
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }

      if (this.invoice.issue_date == "") {
        this.messageAlert =
          "É necessário preencher uma data de emissão para poder continuar";
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }

      const quantity_served = parseInt(this.getTotalSum("quantity_served"));
      const value_served = parseFloat(this.getTotalSum("value_served"));
      if (quantity_served !== parseInt(this.invoice.quantity)) {
        this.typeAlert = "error";
        this.messageAlert =
          "A Quantidade Atendida esta diferente da Quantidade Total";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }
      console.group("Arredondamento");
      console.log(value_served.toFixed(2));
      console.log(this.invoice.value);
      console.log(this.invoice.adjustment);
      console.log(
        (
          parseFloat(this.invoice.value) + parseFloat(this.invoice.adjustment)
        ).toFixed(2)
      );
      console.groupEnd();
      if (
        value_served.toFixed() !==
        (
          parseFloat(this.invoice.value) + parseFloat(this.invoice.adjustment)
        ).toFixed()
      ) {
        this.typeAlert = "error";
        this.messageAlert =
          "O Valor Atendido esta diferente do Valor Total dos produtos (+ Valor de Ajustes)";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }

      const incorrect_quantity_served = this.orders_selected.find(
        (item) =>
          parseInt(item.quantity_served) > parseInt(item.quantity_outstanding)
      );

      if (incorrect_quantity_served !== undefined) {
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        this.messageAlert = `A Quantidade Atendida do Pedido ${incorrect_quantity_served.code} esta maior que a Quantidade Pendente`;
        return false;
      }

      const incorrect_value_served = this.orders_selected.find(
        (item) =>
          parseFloat(item.value_served) > parseFloat(item.value_outstanding)
      );

      if (incorrect_value_served !== undefined) {
        this.typeAlert = "error";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        this.messageAlert = `O Valor Atendido do Pedido ${incorrect_value_served.code} esta maior que o Valor Pendente`;
        return false;
      }

      const data = {};
      data.invoice = this.invoice;
      data.invoice.observation =
        data.invoice.observation === null
          ? ""
          : data.invoice.observation.toUpperCase();
      data.invoice.issue_date = this.dateToEua(data.invoice.issue_date);
      data.orders = this.orders_selected;
      this.save(data);
    },
    async save(data) {
      this.loading = true;
      this.showAlert = false;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}invoice`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.messageAlert = response.message;
        this.typeAlert = "success";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        this.clear();
      } catch (error) {
        // console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao conciliar os pedidos, tente novamente mais tarde";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } finally {
        this.loading = false;
      }
    },
    clear() {
      let oldProvider = this.invoice.provider;
      this.orders = [];
      this.orders_selected = [];
      this.orders_filtered = [];
      this.orders_selected_modal = [];
      this.order_code_filter = "";
      this.invoice = {
        id: "",
        franchise: "",
        provider: oldProvider,
        issue_date: "",
        number: "",
        serie: "1",
        observation: "",
        value: "0.00",
        discount: "0.00",
        quantity: "0",
      };
      this.dateDialog = "";
    },
    clearGetInvoice() {
      this.orders = [];
      this.orders_selected = [];
      this.orders_filtered = [];
      this.orders_selected_modal = [];
      this.order_code_filter = "";
      this.invoice.issue_date = "";
      this.invoice.id = "";
      this.invoice.observation = "";
      this.invoice.value = "0.00";
      this.invoice.value_total = "0.00";
      this.invoice.adjustment = "0.00";
      this.invoice.addition = "0.00";
      this.invoice.discount = "0.00";
      this.invoice.quantity = "0";
      this.dateDialog = "";
    },
    dateToEua(date) {
      if (date == undefined) return "";
      return date.split("/").reverse().join("-");
    },
    dateToBr(date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
    currencyBrToEua(value) {
      return value.toString().replace(/\./gi, "").replace(/,/gi, ".");
    },
    handleClickCalendar() {
      this.dateDialog = this.dateToEua(this.invoice.issue_date);
      this.modalDate = true;
    },
    handlePickerDate() {
      this.modalDate = false;
      this.invoice.issue_date = this.dateToBr(this.dateDialog);
    },
    getTotalSum(field) {
      let total = this.orders_selected.reduce(
        (prev, curr) =>
          prev +
          (!isNaN(parseFloat(curr[field])) ? parseFloat(curr[field]) : 0),
        0
      );
      // console.log(field, total);

      let decimal_fields = [
        "value_total",
        "adjustment",
        "value_outstanding",
        "value_served",
      ];

      return !decimal_fields.includes(field)
        ? parseInt(total)
        : total.toFixed(2);
    },
    async openModalOrder() {
      this.orders_filtered = [];
      this.order_code_filter = "";
      if (this.invoice.provider !== "" && this.invoice.franchise !== "") {
        this.loading = true;
        this.orders = [];
        this.orders_filtered = [];
        try {
          let response = await fetch(
            `${URL}order?franchise=${this.invoice.franchise}&provider=${this.invoice.provider}&screen=conciliation`
          );
          let data = await response.json();
          this.orders = data;
          this.orders_filtered = data.sort((a, b) =>
            a.estimate_date > b.estimate_date ? 1 : -1
          );
        } catch (error) {
          this.orders_filtered = [];
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
      this.modalOrderAdd = true;
    },
    getProviderSelected() {
      // console.log(this.invoice);
      if (this.invoice.provider === "" || this.invoice.provider === null) {
        return "";
      }
      let provider_selected = this.companies_providers.find(
        (item) => item.id == this.invoice.provider
      );
      if (provider_selected) {
        return `${provider_selected.code} - ${provider_selected.name}`;
      }
      return "";
    },
    getFranchiseSelected() {
      if (this.invoice.franchise === "" || this.invoice.franchise === null) {
        return "";
      }
      let company_selected = this.companies.find(
        (item) => item.id === this.invoice.franchise
      );
      if (company_selected) {
        return `${company_selected.code} - ${company_selected.name}`;
      }
      return "";
    },
    getFranchiseSelectedCode() {
      if (this.invoice.franchise === "" || this.invoice.franchise === null) {
        return "";
      }
      let company_selected = this.companies.find(
        (item) => item.id === this.invoice.franchise
      );
      if (company_selected) {
        return `${company_selected.code}`;
      }
      return "";
    },
    handleConfirmModal() {
      this.modalOrderAdd = false;
      // if (this.orders_selected.length === 0) {
      this.orders_selected = this.orders_selected_modal
        .map((id) => this.orders.find((item) => item.id === id))
        .map((item) => ({
          ...item,
          quantity_served: 0,
          value_served: 0,
        }))
        .sort((a, b) => a.code - b.code);
      console.log(this.orders_selected);
      // } else {
      //   this.orders_selected = this.orders_selected_modal.map((id) =>
      //     this.orders.find((item) => item.id === id)
      //   );
      // }
    },
    filterSearchInput() {
      return this.orders_filtered.filter((item) =>
        item.code.includes(this.order_code_filter)
      );
    },
    handleChangeFranchise() {
      this.clearOrders();
    },
    handleChangeProvider() {
      this.clearOrders();
    },
    clearOrders() {
      this.orders_selected = [];
      this.orders_filtered = [];
      this.orders_selected_modal = [];
      this.order_code_filter = "";
    },
    getStatus(status) {
      return getStatusName(status);
    },
    handleBlurQuantityServed(order) {
      if (
        parseInt(order.quantity_served) > parseInt(order.quantity_outstanding)
      ) {
        this.typeAlert = "error";
        this.messageAlert =
          "A Quantidade Atendida não pode ser maior que a Quantidade Pendente";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }
    },
    handleBlurValueServed(order) {
      if (
        parseFloat(order.value_served) > parseFloat(order.value_outstanding)
      ) {
        this.typeAlert = "error";
        this.messageAlert =
          "A Valor Atendido não pode ser maior que o Valor Pendente";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        return false;
      }
    },
    deleteOrder(order) {
      let copyOrders = [
        ...this.orders_selected.filter((item) => item.id !== order.id),
      ];
      this.orders_selected = [...copyOrders];
    },
    async getInvoice() {
      if (this.invoice.number === "" || this.invoice.serie === "") {
        return false;
      }
      // this.clearGetInvoice();
      this.loading = true;
      this.showAlert = false;
      let data = {
        provider_id: this.invoice.provider,
        franchise_id: this.invoice.franchise,
        number: this.invoice.number,
        serie: this.invoice.serie,
      };
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}invoice/search`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        if (response.exist && response.invoice !== null) {
          if (this.editAuto) {
            this.order_edit = response.invoice;
            this.$refs.issue_date.focus();
            this.confirmEditOrder();
            this.editAuto = false;
          } else {
            this.showConfirmEdit = true;
            this.order_edit = response.invoice;
            this.$refs.issue_date.focus();
          }
        } else if (response.exist && response.invoice === null) {
          this.messageAlert =
            "Essa nota já foi faturada, não é possível editar";
          this.typeAlert = "warning";
          this.showAlert = true;
          this.invoice.number = "";
          this.$vuetify.goTo(0, {
            duration: 300,
            offset: 0,
            easing: "easeInOutCubic",
          });
          this.$refs.franchise.focus();
        }
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao validar a nota fiscal, tente novamente mais tarde";
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } finally {
        this.loading = false;
      }
    },
    confirmEditOrder() {
      this.showConfirmEdit = false;
      this.$refs.issue_date.focus();
      this.invoice = {
        id: this.order_edit.id,
        franchise: this.order_edit.franchise_id,
        provider: this.order_edit.provider_id,
        issue_date: this.dateToBr(this.order_edit.issue_date),
        number: this.order_edit.number,
        serie: this.order_edit.serie,
        observation: this.order_edit.observation,
        value: this.order_edit.value,
        value_total: this.order_edit.value_total,
        adjustment: this.order_edit.adjustment,
        discount: this.order_edit.discount,
        addition: this.order_edit.addition,
        quantity: this.order_edit.quantity,
      };

      this.orders_selected = this.order_edit.orders;
      this.orders_selected_modal = this.orders_selected.map((item) => item.id);
      this.orders_selected = this.orders_selected.map((item) => ({
        ...item,
        quantity_outstanding: item.quantity_outstanding + item.quantity_served,
        value_outstanding: (
          parseFloat(item.value_outstanding) + parseFloat(item.value_served)
        ).toFixed(2),
      }));
    },
    cancelEditOrder() {
      this.order_edit = {};
      this.showConfirmEdit = false;
      this.$refs.number.focus();
      this.invoice.number = "";
      this.invoice.serie = "1";
    },
    deleteInvoice() {
      this.showDialogDeleteInvoice = true;
    },
    async confirmDeleteInvoice() {
      this.showDialogDeleteInvoice = false;
      this.loading = true;
      this.ncms = [];
      try {
        let res = await fetch(`${URL}invoice/${this.invoice.id}`, {
          method: "DELETE",
        });
        if (!res.status) {
          throw new Error(res.msg);
        }
        this.clear();
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert = error.message;
        this.showAlert = true;
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } finally {
        this.loading = false;
      }
    },
    handleBlurAdjustment() {
      console.log(this.invoice.adjustment);
    },
    getTotalValueAdjustment() {
      let total = isNaN(parseFloat(this.invoice.value))
        ? 0
        : parseFloat(this.invoice.value);
      let adjustment = isNaN(parseFloat(this.invoice.adjustment))
        ? 0
        : parseFloat(this.invoice.adjustment);

      return total + adjustment;
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}

.compact-form .fs-12 {
  transform: scale(0.75);
  transform-origin: left;
}

.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
